import { render } from "./editMenu.vue?vue&type=template&id=0f8264d4&scoped=true&ts=true"
import script from "./editMenu.vue?vue&type=script&lang=ts"
export * from "./editMenu.vue?vue&type=script&lang=ts"

import "./editMenu.vue?vue&type=style&index=0&id=0f8264d4&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8264d4"]])

export default __exports__